<template>
  <div>
    <div :key="n.ID" :class="n.IsAcknowledged ? 'read' : 'unread'">
      <div v-if="n.Comment">
        <span v-if="n.Comment.IsPrivate">private comment added</span>
        <span
          v-else-if="
            n.Comment.Note.startsWith('![') ||
            n.Comment.Note.startsWith('|') ||
            n.Comment.Note.startsWith('```')
          "
          >comment added</span
        >
        <span v-else>{{ snippet(n.Comment.Note) }}</span>
        <span class="sectionText">
          -
          <span
            v-if="n.Comment.CreatedBy.FirstName && n.Comment.CreatedBy.LastName"
            >{{ n.Comment.CreatedBy.FirstName }}
            {{ n.Comment.CreatedBy.LastName }}</span
          ><span v-else>
            {{ n.Comment.CreatedBy.Email }}
          </span>
          -
          {{ n.Comment.CreatedDate | formatDateTime }}</span
        >
      </div>
      <div v-if="n.Link">
        <span class="" v-if="n && n.Link && n.Link.URL"
          ><a :href="getUrl(n.Link.URL)" target="_blank">{{
            n.Link.Description
          }}</a>
          link added</span
        >
        <span class="">
          -
          <span v-if="n.Link.CreatedBy.FirstName && n.Link.CreatedBy.LastName"
            >{{ n.Link.CreatedBy.FirstName }}
            {{ n.Link.CreatedBy.LastName }}</span
          ><span v-else>
            {{ n.Link.CreatedBy.Email }}
          </span>
          -
          {{ n.Link.CreatedDate | formatDateTime }}</span
        >
      </div>
      <div v-if="n.Document">
        <span class="" v-if="n.Document.FileName"
          ><a @click="downloadDocument(n.Document)">
            {{ n.Document.FileName }}
          </a>
          document uploaded</span
        >
        <span class="">
          -
          <span
            v-if="
              n.Document.CreatedBy.FirstName && n.Document.CreatedBy.LastName
            "
            >{{ n.Document.CreatedBy.FirstName }}
            {{ n.Document.CreatedBy.LastName }}</span
          ><span v-else>
            {{ n.Document.CreatedBy.Email }}
          </span>
          -
          {{ n.Document.CreatedDate | formatDateTime }}</span
        >
      </div>
      <div v-if="!n.Comment && !n.Document && !n.Link"
        >An update was made to the bill</div
      >
    </div></div
  >
</template>
<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import { get, sync, commit, call } from 'vuex-pathify'
import download from 'downloadjs'
export default {
  //model: {
  //	prop: ''
  //},
  props: {
    n: {
      type: Object,
      required: true,
    },
  },
  components: {},
  filters: {},
  data() {
    return {}
  },
  created() {},
  computed: {},
  methods: {
    handleError: call('errors/handleError'),
    getUrl(url) {
      return url.startsWith('http') ? url : 'http://' + url
    },
    snippet(text) {
      text = text
        .toString()
        .split('\n')[0]
        .replace(/(<([^>]+)>)/gi, '')
      if (text.toString().length > 100) {
        return text.toString().substring(0, 100) + '...'
      } else {
        return text
      }
    },
    downloadDocument(doc) {
      let url
      url = `Document/Download/${doc.ID}`
      let headers = { responseType: 'blob' }
      this.$axios.get(url, headers).then(
        (res) => {
          const content = res.headers['content-type']
          const dispo = res.headers['content-disposition']
          var filename = ''
          if (dispo && dispo.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(dispo)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }
          download(res.data, filename, content)
        },
        (error) => {
          this.handleError(error)
          console.log(error)
        }
      )
    },
  },
  watch: {},
}
</script>
<style scoped>
.unread {
  font-weight: bold;
}
.unread h3 {
  font-size: larger;
}
.read {
  color: var(--accent-base);
}
</style>
